import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { AcceptedOffersTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
};
export const schemaLoanRequestResolver_GetOffer = AcceptedOffersTableDefinitionZod.nullable();

export type SchemaLoanRequestResolver_GetOffer = z.infer<typeof schemaLoanRequestResolver_GetOffer>;

export type LoanRequestResolver_GetOffer = Resolver<Arguments, SchemaLoanRequestResolver_GetOffer>;
